import React from "react";
import { useState } from "react";
import Inventory from "./Inventory";
import Transactions from "./Transactions";
import { FiDatabase, FiDollarSign } from "react-icons/fi";

export default function LeasingInformation() {
  const [activeMenu, setActiveMenu] = useState(1);

  const menuItems = [
    { id: 1, label: "Inventory", icon: <FiDatabase size={16} /> },
    { id: 2, label: "Transactions", icon: <FiDollarSign size={16} /> },
  ];

  const activePage = () => {
    switch (activeMenu) {
      case 1:
        return <Inventory />;
      case 2:
        return <Transactions />;
      default:
        return <Inventory />;
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="border-b border-gray-200 mb-4">
        <div className="flex flex-wrap gap-1">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`
                px-6 py-3 flex items-center gap-2 font-medium text-sm rounded-t-lg transition-all
                ${
                  activeMenu === item.id
                    ? "bg-[#002368] text-white border-b-2 border-[#ff5003]"
                    : "hover:bg-gray-50 text-gray-600"
                }
              `}
              onClick={() => setActiveMenu(item.id)}
            >
              {item.icon}
              {item.label}
            </button>
          ))}
        </div>
      </div>
      <div className="flex flex-col">{activePage()}</div>
    </div>
  );
}
